module.exports = __webpack_public_path__ + "img/c05_unitlegionary_Normal_ua.64ce3dfc.webp";